import EntityState from '@/data/EntityState';
import { fetchPayrollsSummaries } from '@/data/payrollCheck/actions/fetchPayrollsSummaries';
import PayrollRecord from '@/data/payrollCheck/models/payrollRecord';
import generateThunkReducers from '@/data/util/generateThunkReducers';
import { mergeEntityItems } from '@/data/util/sliceHelpers';

import { createSlice } from '@reduxjs/toolkit';

const initialState = new EntityState<PayrollRecord>();

const payrollsSummaries = createSlice({
  name: 'payrollCheck/summaries',
  initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: builder => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(fetchPayrollsSummaries.fulfilled, (state, action) => {
      return mergeEntityItems(state, action.payload.items, PayrollRecord);
    });
    generateThunkReducers(builder, 'payrollCheck/summaries');
  },
});

export default payrollsSummaries.reducer;
